<template>
  <div>
 <v-img
        src="././img/tmp/bg1.webp"
        :height="$vuetify.breakpoint.mdAndUp ? 350 : 'auto'"
        lazy-src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAICAgICAgICAgIDAgICAwQDAgIDBAUEBAQEBAUGBQUFBQUFBgYHBwgHBwYJCQoKCQkMDAwMDAwMDAwMDAwMDAz/2wBDAQMDAwUEBQkGBgkNCgkKDQ8ODg4ODw8MDAwMDA8PDAwMDAwMDwwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCABUACYDAREAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAn/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAL/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB/9k="
        class="py-5"
      >
      <v-container
        fill-height
        grid-list-xl
        style="xborder: 1px solid gold;"
      >
        <v-layout
          align-center
          row
          wrap
        >
          <v-flex
            style="xborder: 1px solid gold;"
            md10
            lg6
            offset-sm0
            offset-md1
            offset-lg2
            class="white--text"
            :class="$vuetify.breakpoint.smAndUp ? 'display-3' : 'headline'"
          >
            Die Plattform der Kreishandwerkerschaften
          </v-flex>
          <v-flex
            class="text-xs-center"
            md10
            lg8
            offset-sm0
            offset-md1
            offset-lg2 
          >
           <v-btn
              large
              @click="$vuetify.goTo('#warum')"
            >
             <v-icon left large>expand_more</v-icon>
            Mehrwerte ansehen</v-btn>

            <v-btn
              large
              href="/uploads/docs/lh_vertragsunterlagen_gesamt_kurz.pdf"
              target="_blank"
            >
             <v-icon left large>text_snippet</v-icon>
            Vertragsunterlagen</v-btn>
            <!-- <v-btn
              large
              :to="{ name: 'register'}"
            >Kostenlos eigenes Profil verwalten</v-btn> -->
          </v-flex>
        </v-layout>
          <!-- <v-layout
          align-center
          
          wrap
        >
          <v-flex
            md10
            lg6
            offset-sm0
            offset-md1
            offset-lg2
          >
          <v-btn>Direkt Mehrwerte sichern</v-btn>
</v-flex></v-layout> -->
      </v-container>
    </v-img>

    <v-container>
      <v-layout
        wrap
        style="xborder: 1px solid gold;"
      >
        <v-flex
          xs12
          md10
          offset-md1
          lg8
          offset-lg2
          mb-0
        >
          <v-layout wrap>
            <v-flex
              xs12
              class=" mb-4 mt-5"
              :class="$vuetify.breakpoint.mdAndUp ? 'display-2' : 'headline'"
            >Exklusiv für Innungsmitglieder</v-flex>
            <v-flex
              xs12
              mb-2
              class="headline  lineheight font-weight-light"
            >
            LokalesHandwerk.de ist die Vermittlungs-Plattform der Kreishandwerkerschaften für Innungsfachbetriebe.<br> Ziel ist es, Endkunden an die Innungsbetriebe zu vermitteln - fair, transparent und gewerkeübergreifend.
            </v-flex>

          </v-layout>

        </v-flex>
      </v-layout>
    </v-container>

    <v-container>
      <v-layout
        row
        wrap
        style="xborder: 1px solid gold;"
      >
        <v-flex
          xs12
          md10
          offset-md1
          lg8
          offset-lg2
          mb-0
          style="xborder: 1px solid red;"
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              sm12
              md8 offset-md2
              mb-2
              class="subheading"
            >

              <h2 class="headline mt-3 mb-3">Ihre kostenlosen Mehrwerte von LokalesHandwerk.de:</h2>

              <ul>
                <li><strong>Online Visitenkarte</strong>
                  <p>Ihre Visitenkarte wird vom Kunden über die gesuchte Leistung / Thema gefunden.<br>Diese Daten können auch als Grundlage für Ihre Einträge auf anderen Plattformen dienen, z.B. Google My Business. Dadurch erhöht LokalesHandwerk.de die Sichtbarkeit, die Reichweite und die Erreichbarkeit Ihres Betriebs für Kunden.
</p>
                </li>
                 <li>
                  <strong>Betriebssuche</strong>
                  <p>Einbindung in die Betriebssuche zahlreicher handwerksinterner wie -externer Webseiten.</p>
                </li>
                 <li>
                  <strong>Kundenanfragen</strong>
                  <p>Wir prüfen und sammeln Kundenanfragen im Bezug zu Ihrem jeweiligen Gewerk / Gebiet.<br>Durch unsere faire und transparente Verteilung der Anfragen werden wir von diversen institutionellen Partnern für Projekte genutzt. </p>
                </li>
                <li>
                  <strong>Informationen</strong>
                  <p>Relevante Informationen von verschiedenen Akteuren.</p>
                </li>

                <!-- <li>
                  <strong>Veranstaltungen</strong>
                  <p>Veranstaltung von verschiedenen Innungen, Kreishandwerkerschaften, Banken, Versicherungen, Prüfgesellschaften, Rechtsanwälte etc. </p>
                </li>
                <li>
                  <strong>NEU: Stellenanzeigen</strong>
                  <p>Sie können bei uns Stellenanzeigen einstellen, die automatisch auf diversen anderen Plattformen erscheinen und dadurch eine größere Reichweite haben. </p>
                </li> -->
              </ul>
             

            </v-flex>

          
          </v-layout>
          <!-- <v-flex
              xs12
              mb-2
            >
              Lösung für Innungsmitglieder im digitalen Zeitalter
              <br> Für alle Handwerksbetriebe ? NEIN, ausschließlich für Innungsmitglieder
              <br> LokalesHandwerk.de wird als starke Marke für Innungsmitglieder und Endkunden etabliert
              <br> Qualität. Vertrauen. Nähe.
              <br> Verbraucherzentralen etc. vertrauen dieser Plattform
              <br> Mitmachen ist für Sie als Innungsmitglied kostenlos
              <br> Sie müssen sich nur anmelden

            </v-flex> -->
        </v-flex>
      </v-layout>
    </v-container>

    <!-- <v-parallax
      height="auto"
      src="././img/bg/LH_bg7_sm.jpg"
      jumbotron
      gradient="to top, rgba(0, 0, 0, .75), rgba(0, 0, 0, .75)"
      dark
      class="py-5"
      v-if="testimonials"
    >
      <v-container
        fill-height
        grid-list-xl
      >
        <v-layout
          justify-space-around
          row
          wrap
        >
          <v-flex
            v-for="testimonial in testimonials"
            :key="testimonial.text"
            xs12
            md6
            lg4
          >
            <testimonial :testimonial="testimonial"></testimonial>
          </v-flex>
        </v-layout>
      </v-container>
    </v-parallax> -->

    <v-container>
      <v-layout
        wrap
        style="xborder: 1px solid gold;"
      >
        <v-flex
          xs12
          md10
          offset-md1
          lg8
          offset-lg2
          mb-5
        >
          <v-layout wrap>
            <v-flex
              xs12
              class="mb-4 mt-2"
              :class="$vuetify.breakpoint.mdAndUp ? 'display-2' : 'headline'"
            >In zwei Schritten erledigt</v-flex>

            <v-layout
              xxjustify-space-around
              row
              wrap
            >
              <v-flex
                xs12
                md6
                mt-4
                mx-auto
                class="headline text-xs-center"
              >
                <v-sheet
                  elevation="14"
                  class="pa-4 mx-5"
                  min-width="200px"
                  height="100%"
                >                  
                  <v-layout column>            
                    <v-flex xs12 class="pt-1 pb-0 px-0 text-xs-center">         
                        <strong>1.</strong>
                    </v-flex>
                    <v-flex xs12 class="pb-1 px-0 text-xs-center">
                      Als Benutzer anmelden
                    </v-flex>
                    <v-flex xs12 class="py-1 px-0 text-xs-center">
                    <v-btn
                      large
                      class="mt-4 accent"
                      :to="{ name: 'register'}"
                    >Anmeldung</v-btn>
                    </v-flex>          
                  </v-layout>
                </v-sheet>

              </v-flex>

              <v-flex
                xs12
                md6
                mt-4
                mx-auto
                class="headline text-xs-center"
              >
                <v-sheet
                  elevation="14"
                  class="pa-4 mx-5"
                  min-width="200px"
                  height="100%"
                >
                  <v-layout column>            
                    <v-flex xs12 class="pt-1 pb-0 px-0 text-xs-center">         
                        <strong>2.</strong>
                    </v-flex>
                    <v-flex xs12 class="pb-1 px-0 text-xs-center">
                     Mit Ihrem Betrieb verknüpfen lassen
                    </v-flex>
                    <v-flex xs12 class="py-1 px-0 text-xs-center">
                      <v-btn
                        large
                        class="mt-4 accent"
                        :to="{ name: 'home'}"
                      >Verknüpfung</v-btn>

                    </v-flex>          
                  </v-layout>
                </v-sheet>
              </v-flex>
              <v-flex grow style="visibility: hidden;">iehack</v-flex>
            </v-layout>

          </v-layout>

        </v-flex>

      </v-layout>
    </v-container>

    <v-container>
      <v-layout
        wrap
        style="xborder: 1px solid gold;"
      >
        <v-flex
          xs12
          md10
          offset-md1
          lg8
          offset-lg2
          mb-3
        >
          <h2 class="headline mb-4 mt-2">Häufig gestellte Fragen zu den kostenlosen Mehrwerten:
</h2>

          <v-expansion-panel expand>
            <v-expansion-panel-content >
              <template v-slot:header>
                <div class="headline py-3">An wen richtet sich das Angebot?</div>
              </template>
              <v-card>
                <v-card-text class="subheading px-4">Die Aufgabe von LokalesHandwerk.de ist es, den Innungen und den dazugehörigen Fachbetrieben eine Plattform zu bieten. <br><br>Ziel ist nicht nur die <strong>Vermittlung von Kundenanfragen</strong>, sondern auch die <strong>Förderung des Netzwerkes zwischen den Mitgliedsbetrieben</strong>, sowie die <strong>Mehrwerte einer Innungsmitgliedschaft</strong> stärker in den Vordergrund zu rücken. </v-card-text>
              </v-card>
            </v-expansion-panel-content>
         

          

            <v-expansion-panel-content>
              <template v-slot:header>
                <div class="headline py-3">Warum muss der Betrieb mit meinen Daten verknüpft werden?</div>
              </template>
              <v-card>
                <v-card-text class="subheading px-4">
                  Aus Exklusivitäts- und Datenschutzgründen können wir unsere Informationen nur mit <strong>aktiven Innungsmitgliedern</strong> teilen. Dazu kontaktieren wir Sie kurz und formlos mit den in der jeweiligen Kreishandwerkerschaft vorliegenden Daten. <br>Nur verifizierte Benutzer können auf alle Funktionen von LokalesHandwerk.de zugreifen. </v-card-text>
              </v-card>
            </v-expansion-panel-content>

              <v-expansion-panel-content>
              <template v-slot:header>
                <div class="headline py-3">Warum taucht mein Betrieb nicht auf?</div>
              </template>
              <v-card>
                <v-card-text class="subheading px-4">Wenn Sie Innungsmitglied bei einer mitmachenden Kreishandwerkerschaft sind und trotzdem nicht in den Suchen auftauchen, haben wir Sie wahrscheinlich aus Datenschutzgründen nicht angezeigt. In diesem Fall kontaktieren Sie uns bitte unter <a href="mailto:info@lokaleshandwerk.de">info@lokaleshandwerk.de</a> oder fragen bei Ihrer Kreishandwerkerschaft nach.</v-card-text>
              </v-card>
            </v-expansion-panel-content>

          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </v-container>

    <v-card
      jumbotron
      gradient="to top, rgba(0, 0, 0, .75), rgba(0, 0, 0, .75)"
      dark
      flat
      class="pt-5 pb-0 mt-4"
      id="warum"
    >
     <v-container>
        <v-layout
          wrap
          style="xborder: 1px solid gold;"
        >
          <v-flex
            xs12
            md10
            offset-md1
            lg8
            offset-lg2
            mb-0
          >
    <h2
      :class="$vuetify.breakpoint.mdAndUp ? 'display-2' : 'headline'"
      class="mb-3 lineheightheadline"
    >
    Weshalb Sie sich für LokalesHandwerk.de entscheiden sollten? Innungsfachbetriebe erklären es im Video! </h2>
          </v-flex>
        </v-layout>
     </v-container>
      <MitmachenVideo></MitmachenVideo>
      <v-container>
        <v-layout
          wrap
          style="xborder: 1px solid gold;"
        >
          <v-flex
            xs12
            md10
            offset-md1
            lg8
            offset-lg2
            mb-5
          >
            <h2
              :class="$vuetify.breakpoint.mdAndUp ? 'display-2' : 'headline'"
              class="mb-3 lineheightheadline"
            >Zusätzliche kostenpflichtige Mehrwerte</h2>

            <v-layout
              wrap
              mt-3
            >

              <v-flex
                xs12
                class="subheading"
              >
                <div class="headline font-weight-light lineheight mt-3 mb-3">
                  LokalesHandwerk.de bietet Ihnen über die kostenlosen Elemente hinaus auch noch weitere Mehrwerte, die Sie kostengünstig aktivieren können:</div><br><br>

                <v-layout
                  row
                  wrap
                >
                  <v-flex
                    xs1
                    class="text-xs-center my-3"
                  >
                    <v-icon left>check_circle_outline</v-icon>
                  </v-flex>
                  <v-flex
                    xs11
                    my-3
                  >Individuelle Unternehmens-Präsentation</v-flex>

                  <v-flex
                    xs1
                    class="text-xs-center my-3"
                  >
                    <v-icon left>check_circle_outline</v-icon>
                  </v-flex>
                  <v-flex
                    xs11
                    my-3
                  > Individuelle Suchbegriffe</v-flex>

                  <v-flex
                    xs1
                    class="text-xs-center my-3"
                  >
                    <v-icon left>check_circle_outline</v-icon>
                  </v-flex>
                  <v-flex
                    xs11
                    my-3
                  > Integration von Bildern, Videos, Texten, Öffnungszeiten, 360°-Panoramen, SocialMedia-Kanäle etc. auf Ihrem Profil </v-flex>

                  <v-flex
                    xs1
                    class="text-xs-center my-3"
                  >
                    <v-icon left>check_circle_outline</v-icon>
                  </v-flex>
                  <v-flex
                    xs11
                    my-3
                  > Persönliche Betreuung</v-flex>

                  <v-flex
                    xs1
                    class="text-xs-center my-3"
                  >
                    <v-icon left>check_circle_outline</v-icon>
                  </v-flex>
                  <v-flex
                    xs11
                    my-3
                  >Gewerkeübergreifende Findbarkeit Ihres Profils</v-flex>
                  <v-flex
                    xs1
                    class="text-xs-center my-3"
                  >
                    <v-icon left>check_circle_outline</v-icon>
                  </v-flex>
                   <v-flex
                    xs11
                    my-3
                  >Eigene .de-Domain mit Ihrem Namen möglich</v-flex>
                  <v-flex
                    xs1
                    class="text-xs-center my-3"
                  >
                    <v-icon left>check_circle_outline</v-icon>
                  </v-flex>
                  <!-- <v-flex
                    xs11
                    my-3
                  >NEU: Comfort-Service: Wir bieten auch einen Comfort-Service an, bei der wir Sie kostengünstig bei der professionellen Formulierung der Stellenanzeige unterstützen. Die Stellenanzeigen werden speziell optimiert, sodass hier eingetragene Stellen auf diversen anderen Plattformen auftauchen und einfacher über Suchmaschinen zu finden sind.</v-flex>
                   <v-flex
                    xs1
                    class="text-xs-center my-3"
                  >
                    <v-icon left>check_circle_outline</v-icon>
                  </v-flex> -->
                  <v-flex
                    xs11
                    my-3
                  >Gerne vermitteln wir bei Bedarf auch Fotografen, Videografen für die Erstellung von Materialien</v-flex>

                   <v-flex
                    xs1
                    class="text-xs-center my-3"
                  >
                    <v-icon left>check_circle_outline</v-icon>
                  </v-flex>
                  <v-flex
                    xs11
                    my-3
                  >Wir können Ihr Profil auch auf ihre eigene Homepage weiterleiten.</v-flex>
                </v-layout>

                <!-- <v-icon left>check_circle_outline</v-icon> Individuelle Unternehmens-Präsentation auf Ihrem Profil<br><br>

                <v-icon left>check_circle_outline</v-icon>  Individuelle Suchbegriffe<br><br>
                <v-icon left>check_circle_outline</v-icon>  Integration von Bildern, Videos, Texten, Öffnungszeiten, 360°-Panoramen, SocialMedia-Kanäle etc. auf Ihrem Profil <br><br>
                <v-icon left>check_circle_outline</v-icon>  Persönliche Betreuung (Wir bauen Ihr Profil)<br><br>
                <v-icon left>check_circle_outline</v-icon>  Gewerkeübergreifende Findbarkeit Ihres Profils<br><br> -->

                <div class="mt-4 headline font-weight-light lineheight"> Verwendbare Materialien wie Teamfotos, Vorher-Nachher Bilder Ihrer Arbeit oder Zertifikate zu Ihren Leistungen können Sie uns gerne zusenden. Diese werden dann von unserem Grafiker bearbeitet und in Ihr Profil integriert. Wir legen großen Wert auf Datensicherheit.</div>

              </v-flex>
<!-- 
              <v-flex
                xs12
                class="subheading mt-4"
              >

                <v-divider dark> </v-divider>

                <h2 class="headline font-weight-light mb-1 mt-5">Beispiele für umfassende Profile</h2>

                <v-container
                  grid-list-lg
                  v-if="vorgestelltebetriebe"
                >
                  <v-layout>
                    <v-flex xs12>
                      <v-layout
                        row
                        wrap
                      >
                        <v-flex
                          xs12
                          sm6
                          md4
                          lg4
                          xl3
                          v-for="betrieb in vorgestelltebetriebe"
                          :key="betrieb.id"
                          mb-3
                        >
                          <v-card
                            hover
                            tile
                            light
                            :to="{name: 'showCompany', params: { id: betrieb.slug }}"
                          >
                            <v-card-title
                              primary-title
                              class="cardbackground py-3 mouseoverlink"
                            >
                              <v-layout row>
                                <v-flex xs12>

                                  <span
                                    v-if="betrieb.image_logo"
                                    class="px-3"
                                  >
                                    <v-img
                                      :src="betrieb.image_logo"
                                      contain
                                      max-height="140"
                                    ></v-img>
                                  </span>
                                  <h4
                                    class="title linehoeher"
                                    flat
                                  >{{ betrieb.name }}</h4>

                                </v-flex>
                              </v-layout>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-layout
                              row
                              class="px-3"
                              v-if="betrieb.innung"
                            >
                              <v-flex
                                xs8
                                align-self-center
                                class="subheading"
                              >{{ betrieb.innung.name}}</v-flex>
                              <v-flex v-if="betrieb.innung.logo">
                                <v-img :src="betrieb.innung.logo"></v-img>
                              </v-flex>
                            </v-layout>

                            <div v-if="betrieb.innungen && betrieb.innungen.length > 0">
                              <v-layout
                                row
                                class="pa-3"
                                v-for="innung in betrieb.innungen"
                                :key="innung.name"
                              >
                                <v-flex
                                  xs8
                                  align-self-center
                                  class="subheading"
                                >{{ innung.name}}</v-flex>
                                <v-flex v-if="innung.logo">
                                  <v-img :src="innung.logo"></v-img>
                                </v-flex>
                              </v-layout>
                            </div>

                          </v-card>

                        </v-flex>
                      </v-layout>

                    </v-flex>
                  </v-layout>
                </v-container>

              </v-flex> -->
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <v-container>
      <v-layout
        wrap
        style="xborder: 1px solid gold;"
      >
      
             
        <v-flex
          xs12
          md10
          offset-md1
          lg8
          offset-lg2
          mb-0
          id="mehrwerte"
        >
          <v-layout wrap>
            <v-flex
              xs12
              class=" mb-4 mt-5"
              :class="$vuetify.breakpoint.mdAndUp ? 'display-2' : 'headline'"
            >Sie möchten sich diese zusätzlichen Mehrwerte sichern?</v-flex>
            <v-flex
              xs12
              mb-2
              class="headline font-weight-light"
            > Die Konditionen der Mitgliedschaft umfassen folgende Punkte:
            </v-flex>

            <v-flex
              xs12
              md6
              my-4
            >

              <ul
                style="xlist-style-type: none;"
                class="subheading"
              >
                <li class="my-3">25,00 €/netto pro Monat</li>
                <!-- <li class="my-3">100,00 €/netto einmalige Einrichtungsgebühr</li> -->
                <li class="my-3">Kündigungsfrist beträgt 3 Monate zum Jahresende</li>
                <li class="my-3">Die Mitgliedschaft endet automatisch mit Austritt aus Ihrer Innung</li>

              </ul>

            </v-flex>

            <v-flex
              xs12
              md6
              my-4
              class="text-xs-center"
            >

              <v-btn
                class="accent py-3 mb-4"
                large
                style="height: 80px;"
                href="/uploads/docs/lh_vertragsunterlagen_gesamt_kurz.pdf" target="_blank"
              >Download<br>Antragsformular <v-icon right>text_snippet</v-icon></v-btn>

              <br>oder im internen Bereich

            </v-flex>

          </v-layout>

        </v-flex>
       <v-flex
                xs12
                md10
                offset-md1
                lg8
                offset-lg2
                mb-0
                class="subheading mt-4"
              >

                <v-divider dark> </v-divider>

                <h2 class="headline font-weight-light mb-1 mt-5">Beispiele für umfassende Profile</h2>

                <v-container
                  grid-list-lg
                  v-if="vorgestelltebetriebe"
                >
                  <v-layout>
                    <v-flex xs12>
                      <v-layout
                        row
                        wrap
                      >
                        <v-flex
                          xs12
                          sm6
                          md4
                          lg4
                          xl3
                          v-for="betrieb in vorgestelltebetriebe"
                          :key="betrieb.id"
                          mb-3
                        >
                          <v-card
                            hover
                            tile
                            light
                            min-height="355"
                            :to="{name: 'showCompany', params: { id: betrieb.slug }}"
                          >
                            <v-card-title
                              primary-title
                              class="cardbackground py-3 mouseoverlink"
                            >
                              <v-layout row>
                                <v-flex xs12>

                                  <span
                                    v-if="betrieb.image_logo"
                                    class="px-3"
                                  >
                                    <v-img
                                      :src="betrieb.image_logo"
                                      contain
                                      max-height="140"
                                    ></v-img>
                                  </span>
                                  <h4
                                    class="title linehoeher"
                                    flat
                                  >{{ betrieb.name }}</h4>

                                </v-flex>
                              </v-layout>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-layout
                              row
                              class="px-3"
                              v-if="betrieb.innung"
                            >
                              <v-flex
                                xs8
                                align-self-center
                                class="subheading"
                              >{{ betrieb.innung.name}}</v-flex>
                              <v-flex v-if="betrieb.innung.logo">
                                <v-img :src="betrieb.innung.logo"></v-img>
                              </v-flex>
                            </v-layout>

                            <div v-if="betrieb.innungen && betrieb.innungen.length > 0">
                              <v-layout
                                row
                                class="pa-3"
                                v-for="innung in betrieb.innungen"
                                :key="innung.name"
                              >
                                <v-flex
                                  xs8
                                  align-self-center
                                  class="subheading"
                                >{{ innung.name}}</v-flex>
                                <v-flex v-if="innung.logo">
                                  <v-img :src="innung.logo"></v-img>
                                </v-flex>
                              </v-layout>
                            </div>

                          </v-card>

                        </v-flex>
                      </v-layout>

                    </v-flex>
                  </v-layout>
                </v-container>

              </v-flex>
              </v-layout>
              
    </v-container>



    <v-divider></v-divider>
    <v-parallax
      height="450"
      src="././img/bg/LH_bg7_sm.jpg"
      jumbotron
      gradient="to top, rgba(0, 0, 0, .75), rgba(0, 0, 0, .75)"
      dark
      v-if="testimonials"
    >
      <!-- <v-container
        fill-height
        grid-list-xl
      >
        <v-layout
          justify-space-around
          row
          wrap
        >
          <v-flex
            v-for="testimonial in testimonials"
            :key="testimonial.text"
            xs12
            md6
            lg4
            my-3
          >
            <testimonial :testimonial="testimonial"></testimonial>
          </v-flex>
        </v-layout>
      </v-container> -->

      <v-card
        flat
        color="transparent"
        gradient="to top, rgba(0, 0, 0, .75), rgba(0, 0, 0, .75)"
        class="py-1"
      >
        <v-layout
          justify-center
          row
          mt-2
          mb-3
        >
          <v-card
            width="450px"
            height="104"
          >
            <v-img
              aspect-ratio
              contain
              src="img/kreishandwerkerschaften.png"
            ></v-img>
          </v-card>
        </v-layout>
      </v-card>
    </v-parallax>

    <!-- 
    <v-card
      flat
      color="transparent"
      gradient="to top, rgba(0, 0, 0, .75), rgba(0, 0, 0, .75)"
      class="py-5 mt-4"
    >
      <v-layout
        justify-center
        row
        mt-2
        mb-3
      >
        <v-card
          width="450px"
          height="104"
        >
          <v-img
            aspect-ratio
            contain
            src="img/kreishandwerkerschaften.png"
          ></v-img>
        </v-card>
      </v-layout>
    </v-card> -->

  </div>
</template>

<script>
import Testimonial from '~/components/mitmachen/Testimonial.vue'
import StartVorgestellte from '~/components/startseite/StartVorgestellte.vue'
import MitmachenVideo from '~/components/mitmachen/MitmachenVideo.vue'

export default {
  components: {
    Testimonial,
    StartVorgestellte,
    MitmachenVideo
  },
  metaInfo () {
    return {
      title: 'Mitmachen'
    }
  },

  // data: () => ({
  data () {
    return {
      items: ['././img/hwbg7.jpg'],
      testimonials: [
        {
          text:
            'Der Wettlauf um den Kunden hat längst begonnen, viele Hersteller suchen schon jetzt den Kontakt zum Endkunden. Jeder Handwerksbetrieb braucht eine zukunftsfähige Plattformstrategie, vielleicht nicht sofort, aber spätestens innerhalb der nächsten zwei bis drei Jahre wenn er diesen Wettlauf nicht verlieren will. LokalesHandwerk stellt genau diese Lösung und das vom Handwerk gesteuert und finanziert.',
          person: 'Martin van Beek, ',
          firma: 'SHK-Meister',
          slug: ''
        },
        {
          text:
            'LokalesHandwerk.de ist nun endlich die erste Plattform die aus dem Innungshandwerk kommt.',
          person: 'Marc Kecker',
          firma: 'Malermeister',
          slug: ''
        },
        {
          text:
            'Zum Glück habe ich durch LokalesHandwerk keine neuen Kunden bekommen',
          person: 'Max Mustermann',
          firma: 'Maler Essen',
          slug: ''
        }
      ],
      vorgestelltebetriebe: [
        {
          id: 179,
          name: 'Unger u. Gronke GmbH',
          connected: true,
          premium: 1,
          premium_freigeschaltet: 1,
          slug: 'unger-u-gronke-gmbh-essen',
          stadtteil: 'Frillendorf',
          stadt: 'Essen',
          geo_lat: 51.4619,
          geo_lng: 7.03866,
          telefon: '0201/ 21 67 66',
          website: 'http://www.ungergronke.de/',
          email: 'info@ungergronke.de',
          innung: {
            id: 15,
            name: 'Tischler - Innung Essen',
            logo: 'uploads/Innungen/Essen/essen_tischler.png',
            stadt: 'Essen'
          },
          innungen: [],
          telefon_link: '0201216766',
          profilfarbe: '#a60000',
          kurztext:
            'Unger und Gronke ist ein klassisches, inhabergeführtes Unternehmen.\r\n\r\n                                   Möbel • kreativ • anders',
          image_logo: 'uploads/PremiumBetriebe/Essen/Unger Gronke/Logo_neu.png'
        },
        {
          id: 223,
          name: 'Beinert-Knotte Elektro GmbH',
          connected: true,
          premium: 1,
          premium_freigeschaltet: 1,
          slug: 'beinert-knotte-elektro-gmbh-essen',
          stadtteil: 'Frintrop',
          stadt: 'Essen',
          geo_lat: 51.4734,
          geo_lng: 6.91446,
          telefon: '0201 / 8 69 28-0',
          website: 'https://www.beinert-knotte.de/',
          email: 'info@beinert-knotte.de',
          innung: {
            id: 2,
            name: 'Elektro Innung Essen',
            logo: 'uploads/Innungen/Essen/essen_elektro.png',
            stadt: 'Essen'
          },
          innungen: [],
          telefon_link: '0201869280',
          profilfarbe: '#ffcc00',
          kurztext: 'Exzellente Technik für anspruchsvolle Menschen',
          image_logo:
            'uploads/PremiumBetriebe/Essen/Logos_Betriebe_bis erster Rechnung_20180731/19_knotte_neu.png'
        },
        {
          id: 8233,
          name: 'Schmeling GmbH',
          connected: true,
          premium: 1,
          premium_freigeschaltet: 1,
          slug: 'schmeling-gmbh-mulheim',
          stadtteil: 'Saarn',
          stadt: 'Mülheim',
          geo_lat: 51.3931,
          geo_lng: 6.87457,
          telefon: '0208 / 48 41 50',
          website: 'https://www.schmeling-gmbh.de',
          email: 'schmeling@schmeling-gmbh.de',
          innung: null,
          innungen: [
            {
              id: 188,
              name: 'Tischler-Innung Oberhausen-Mülheim',
              logo: 'uploads/Innungen/MülheimOberhausen/mo_tischler.png',
              stadt: 'Mülheim'
            }
          ],
          telefon_link: '0208484150',
          profilfarbe: '#00529e',
          kurztext: 'Spezialist für Messe- und Innenausbau',
          image_logo: 'uploads/PB/Oberhausen/schmeling/schmeling_3.png'
        },
        {
          id: 319,
          name: 'Elektro Randl',
          connected: true,
          premium: 1,
          premium_freigeschaltet: 1,
          slug: 'elektro-randl-essen',
          stadtteil: 'Nord',
          stadt: 'Essen',
          geo_lat: 51.4696,
          geo_lng: 7.00406,
          telefon: '0201 / 28 96 58 88',
          website: 'https://www.elektro-randl.de/',
          email: 'info@elektro-randl.de',
          innung: {
            id: 2,
            name: 'Elektro Innung Essen',
            logo: 'uploads/Innungen/Essen/essen_elektro.png',
            stadt: 'Essen'
          },
          innungen: [],
          telefon_link: '020128965888',
          profilfarbe: '#59097b',
          kurztext: null,
          image_logo:
            'uploads/PremiumBetriebe/Essen/Logos_Betriebe_bis erster Rechnung_20180731/5_randl_neu.png'
        },
        {
          id: 332,
          name: 'Schröer-Beckhaus GmbH',
          connected: true,
          premium: 1,
          premium_freigeschaltet: 1,
          slug: 'schroer-beckhaus-gmbh-essen',
          stadtteil: 'Bergeborbeck',
          stadt: 'Essen',
          geo_lat: 51.4866,
          geo_lng: 6.95251,
          telefon: '02 01/ 8 66 09-0',
          website: 'http://www.schroeer-beckhaus.de/',
          email: 's-b@schroeer-beckhaus.de',
          innung: {
            id: 2,
            name: 'Elektro Innung Essen',
            logo: 'uploads/Innungen/Essen/essen_elektro.png',
            stadt: 'Essen'
          },
          innungen: [],
          telefon_link: '0201866090',
          profilfarbe: '#1d4b96',
          kurztext: null,
          image_logo:
            'uploads/PremiumBetriebe/Essen/Logos_Betriebe_bis erster Rechnung_20180731/20_schröer beckhaus_neu.jpg'
        },
        {
          id: 286,
          name: 'Elektro Jost GmbH',
          connected: true,
          premium: 1,
          premium_freigeschaltet: 1,
          slug: 'elektro-jost-gmbh-essen',
          stadtteil: 'Burgaltendorf',
          stadt: 'Essen',
          geo_lat: 51.4165,
          geo_lng: 7.11787,
          telefon: '0201 / 815 03 777',
          website: 'http://www.elektrojost.de/',
          email: 'info@elektrojost.de',
          innung: {
            id: 2,
            name: 'Elektro Innung Essen',
            logo: 'uploads/Innungen/Essen/essen_elektro.png',
            stadt: 'Essen'
          },
          innungen: [],
          telefon_link: '020181503777',
          profilfarbe: '#0080b9',
          kurztext:
            'Bereits seit 1995 richten wir unsere Dienstleistungen kontinuierlich an den Bedürfnissen und Wünschen unserer Kunden aus.',
          image_logo:
            'uploads/PremiumBetriebe/Essen/Elektro Jost/elektro_jost_logo.png'
        },
        {
          id: 596,
          name: 'van Beek GmbH & Co. KG',
          connected: true,
          premium: 1,
          premium_freigeschaltet: 1,
          slug: 'van-beek-gmbh-co-kg-essen',
          stadtteil: 'Nord',
          stadt: 'Essen',
          geo_lat: 51.4694,
          geo_lng: 7.00498,
          telefon: '02 01 / 31 34 82',
          website: 'http://www.shk-van-beek.de/',
          email: 'info@shk-van-beek.de',
          innung: {
            id: 4,
            name: 'Innung für Sanitär- und Heizungstechnik Essen',
            logo: 'uploads/Innungen/Essen/essen_shk.png',
            stadt: 'Essen'
          },
          innungen: [],
          telefon_link: '0201313482',
          profilfarbe: '#2965af',
          kurztext: null,
          image_logo: 'uploads/PB/Essen/HeizungvanBeek/logo_vanbeek.png'
        },
        {
          id: 1085,
          name: 'MASTO DEKORATIONEN GmbH & Co. KG',
          connected: true,
          premium: 1,
          premium_freigeschaltet: 1,
          slug: 'masto-dekorationen-gmbh-co-kg-essen',
          stadtteil: null,
          stadt: 'Essen',
          geo_lat: 51.4622,
          geo_lng: 7.0397,
          telefon: '0201 - 89 18 - 3',
          website: 'https://www.masto.de',
          email: 'info@masto.de',
          innung: {
            id: 16,
            name: 'Raumausstatter- und Sattler - Innung Essen',
            logo: 'uploads/Innungen/Essen/essen_raumausstatter.png',
            stadt: 'Essen'
          },
          innungen: [],
          telefon_link: '020189183',
          profilfarbe: '#ece9da',
          kurztext:
            'Exklusive textile Raumausstattung für private und gewerbliche Kunden.\r\nMit moderner Raumausstattung schöner wohnen und eleganter arbeiten.',
          image_logo:
            'uploads/PremiumBetriebe/Essen/Raumausstatter_MASTO_Scholten/essen-masto-logo.png'
        },
        {
          id: 6092,
          name: 'Markus Henkel Dächer und mehr GmbH',
          connected: true,
          premium: 1,
          premium_freigeschaltet: 1,
          slug: 'markus-henkel-dacher-und-mehr-gmbh-goch',
          stadtteil: 'Nierswalde',
          stadt: 'Goch',
          geo_lat: 51.7164,
          geo_lng: 6.1114,
          telefon: '02823 / 41 00 77',
          website: 'http://www.henkel-daecher.de',
          email: 'henkel-daecher@web.de',
          innung: null,
          innungen: [
            {
              id: 126,
              name: 'Dachdecker-Innung des Kreises Kleve',
              logo: 'uploads/Innungen/Essen/essen_dachdecker.png',
              stadt: 'Kleve'
            }
          ],
          telefon_link: '02823410077',
          profilfarbe: '#1a6940',
          kurztext: null,
          image_logo: null
        },
        {
          id: 929,
          name: '2-Rad Schulte Meisterbetrieb',
          connected: true,
          premium: 1,
          premium_freigeschaltet: 1,
          slug: '2-rad-schulte-meisterbetrieb-essen-kettwig',
          stadtteil: 'Kettwig',
          stadt: 'Essen-Kettwig',
          geo_lat: 51.3642,
          geo_lng: 6.93821,
          telefon: '02054 / 93 83 954',
          website: 'https://www.2-rad-schulte.de/',
          email: '2-rad-schulte@web.de',
          innung: {
            id: 14,
            name: 'Innung für Zweiradtechnik Essen',
            logo: 'uploads/Innungen/Essen/essen_Zweiradmechaniker.png',
            stadt: 'Essen'
          },
          innungen: [],
          telefon_link: '020549383954',
          profilfarbe: '#689F38',
          kurztext:
            'Willkommen bei 2-Rad Schulte, Ihrem Fachgeschäft für Fahrräder/ Mountainbikes, Pedelec/ E-Bikes, Kinderfahrzeuge und Motorroller.',
          image_logo:
            'uploads/PremiumBetriebe/Essen/Logos_Betriebe_bis erster Rechnung_20180731/10_2 rad schulte_neu.png'
        }
      ]
    }
  }
}
</script>


<style >
.lineheight {
  line-height: 44px !important;
}
.lineheightheadline {
  line-height: 74px !important;
}
.lineheightzwei {
  line-height: 1.5%;
}
</style>